export enum LineItemInvalidateReasonEnum {
  INVALID_DIMENSIONS = 'Invalid dimensions.',
  NOT_AVAILABLE_IN_PRODUCT_LINE = 'Not Available in Selected Product Line - Replace or Delete',
  INVALID_MODIFICATION = 'Invalid Modification - Replace or Delete',
}

/** Line item has no catalog record in the style's product line (set on convert),
 * so it can only be replaced or deleted. Must be an exact match - the same text with
 * a leading space is used for inactive catalog items, whose data still exists.
 */
export const isLineItemNotAvailableInProductLine = (
  lineItem?: { isValid?: boolean; invalidateReason?: string } | null
) =>
  lineItem?.isValid === false &&
  lineItem.invalidateReason ===
    LineItemInvalidateReasonEnum.NOT_AVAILABLE_IN_PRODUCT_LINE;

/** Mod is not available in selected product line (convert, import) or for its line item
 * (kept on replace), so it can only be replaced or deleted.
 */
export const isModificationToReplaceOrDelete = (
  modification?: { isValid?: boolean; invalidateReason?: string } | null
) =>
  isLineItemNotAvailableInProductLine(modification) ||
  (modification?.isValid === false &&
    modification.invalidateReason ===
      LineItemInvalidateReasonEnum.INVALID_MODIFICATION);
